import { useState, useEffect, useRef } from "react";

export default function MultiSelectDropdown({
  label = "",
  options = [],
  selectedValues = [],
  onChange,
  placeholder = "Select options",
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef();

  const filteredOptions = options.filter((opt) =>
    opt.label.toLowerCase().includes(search.toLowerCase())
  );

  // Close dropdown when clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelection = (value) => {
    let updatedValues;

    if (selectedValues.includes(value)) {
      updatedValues = selectedValues.filter((v) => v !== value);
    } else {
      updatedValues = [...selectedValues, value];
    }

    onChange(updatedValues);
  };

  return (
    <div className="w-full mb-4" ref={dropdownRef}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}

      <div
        className={`border rounded-lg px-3 py-2 bg-white cursor-pointer ${
          disabled ? "opacity-50 cursor-not-allowed" : ""
        }`}
        onClick={() => !disabled && setOpen(!open)}
      >
        {selectedValues.length === 0 ? (
          <span className="text-gray-400">{placeholder}</span>
        ) : (
          <div className="flex gap-2 flex-wrap">
            {selectedValues.map((value) => {
              const opt = options.find((o) => o.value === value);
              return (
                <span
                  key={value}
                  className="bg-blue-100 text-blue-800 px-2 py-1 rounded-md text-xs flex items-center"
                >
                  {opt?.label}
                </span>
              );
            })}
          </div>
        )}
      </div>

      {open && (
        <div className="border bg-white rounded-lg mt-1 shadow-md absolute z-50 w-full max-h-60 overflow-auto">
          {/* Search box */}
          <div className="p-2 border-b">
            <input
              type="text"
              className="w-full px-2 py-1 border rounded focus:outline-none"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* Options */}
          <div className="max-h-48 overflow-y-auto p-1">
            {filteredOptions.length === 0 && (
              <div className="text-gray-400 text-center py-2 text-sm">
                No options found
              </div>
            )}

            {filteredOptions.map((opt) => (
              <label
                key={opt.value}
                className="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={selectedValues.includes(opt.value)}
                  onChange={() => handleSelection(opt.value)}
                />
                <span>{opt.label}</span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
